import React from 'react'
import { List } from './components'
import { DashboardSubNavs, Container, Loader } from '../../components'
import { Route } from 'react-router-dom'
import { useViewport } from '../../utils'
import { useSelector } from 'react-redux'
import { DashboardTicketsDetail } from '../dashboard-tickets-detail'
import { useInternationalization } from '../../features/i18n'

const ListWithLoader = ({data}) => {
  const status = useSelector(state => state.account.status_tickets)
  return <div className="max-h-screen overflow-y-auto">
    {
      status === 'loading' &&
      <div className="flex items-center justify-center py-5">
        <Loader />
      </div>
    }
    <List data={data}/>
  </div>
}

const ListingContent = ({ data }) => {
  const { isDesktop } = useViewport()
  const { translate } = useInternationalization()

  const subroutes = [
    {
      label: translate('EVENT', 'upcoming'),
      route: '/dashboard/tickets',
      exact: true
    },
    {
      label: translate('EVENT', 'past'),
      route: '/dashboard/tickets/past',
    }
  ]

  return <>
    {
      isDesktop ? (
        <div>
          <PageHeader />
          <DashboardSubNavs links={subroutes}/>
          <ListWithLoader data={data}/>
        </div>
      ) : (
        <>
          <DashboardSubNavs links={subroutes} />
          <Container>
            <ListWithLoader data={data}/>
          </Container>
        </>
      )
    }
  </>
}

const PageHeader = () => {
  const { translate } = useInternationalization()

  return (
    <div className="mb-10">
      <h1 className="text-4xl font-bold font-primary">
        {translate('DASHBOARD', 'event_tickets')}
      </h1>
    </div>
  )
}

const DashboardTickets = () => {
  const rawData = useSelector(state => state.account.tickets)
  const data_past = []
  const data = []

  for (let index = 0; index < rawData.length; index++) {
    const element = rawData[index];
    if (element.is_past) {
      data_past.push(element)
    } else {
      data.push(element)
    }
  }

  return <>
    <Route path="/dashboard/tickets/past" exact>
      <ListingContent data={data_past}/>
    </Route>
    <Route
      path="/dashboard/tickets/detail/:id"
      exact
      render={(props) => <DashboardTicketsDetail {...props}/>}
    />
    <Route path="/dashboard/tickets" exact>
      <ListingContent data={data}/>
    </Route>
  </>
}

export { DashboardTickets }
